export default __webpack_public_path__ + "static/media/fumsoft.03fc1cf6.svg";